import { render, staticRenderFns } from "./CreateSupplier.vue?vue&type=template&id=564f56cc&scoped=true"
import script from "./CreateSupplier.vue?vue&type=script&lang=js"
export * from "./CreateSupplier.vue?vue&type=script&lang=js"
import style0 from "./CreateSupplier.vue?vue&type=style&index=0&id=564f56cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f56cc",
  null
  
)

export default component.exports